import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("America/New_York")

export function theaterDate(value?: dayjs.ConfigType) {
  return dayjs(value).tz("America/New_York")
}

/**
 * ACF's date_time_picker return value has no reliable timezone info attached (the site's
 * date_time GraphQL fields inconsistently label it with the wrong offset/abbreviation,
 * e.g. "2026-09-04UTC18:27:00+00:00" or "2026-09-04AEST18:27:00+10:00"), but the date/time
 * digits themselves are always the correct site-local wall-clock value. Extract just those
 * digits and parse as a naive local time so no timezone conversion is applied.
 */
export function parseAcfDateTime(value: string | null | undefined) {
  if (!value) return null
  const match = value.match(/^(\d{4}-\d{2}-\d{2}).*?(\d{2}:\d{2}:\d{2})/)
  if (!match) return dayjs(value)
  return dayjs(`${match[1]}T${match[2]}`)
}

const FORMATS = {
  DATE_AND_TIME: "ddd MMM D, h:mma",
} satisfies Record<string, string>

export function formatDate(value: dayjs.ConfigType, format: keyof typeof FORMATS | (string & {})) {
  return dayjs(value)
    .tz("America/New_York")
    .format(format in FORMATS ? (FORMATS as any)[format] : format)
}
